import classnames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import WarningBlock from '@/components/UI/WarningBlock';
import { RoundLink } from '@/components/UI/RoundLink';
import { APP_LINKS } from '@/helpers/links';
import s from './index.module.scss';

export const PaymentFailure = ({ amount }) => {
  const { t } = useTranslation('cash');
  return (
    <div className={s.wrapper}>
      <h1 className={classnames(s.title, 'f-26 f-500')}>
        {t('payment_failure.oops_something_went_wrong')}
      </h1>

      <WarningBlock withBorder className={s.message}>
        <div className="f-16 f-400">
          <Trans
            ns="cash"
            i18nKey="payment_failure.payment_of_failed"
            values={{
              amount: prettyFloatMoney(amount),
            }}
            components={{
              Span: <span className="f-500" />,
            }}
          />
        </div>
      </WarningBlock>

      <div className={s.buttons}>
        <RoundLink
          path={APP_LINKS.dashboard}
          label={t('payment_failure.go_to_dashboard')}
          fillBackground
          className={s.button}
        />
        <RoundLink
          path={APP_LINKS.addFunds}
          label={t('payment_failure.add_cash')}
          className={s.button}
        />
      </div>
    </div>
  );
};
